/**
 * @file  routes/index.ts
 * @description  router component which defines the application level routes and mapping/loading of the component that should handle the rendering
 *
 * @author ogarcia (ozkary)
 *
 */
import { memo, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from './config';
import { expandPagePaths, routeInfo } from './pageLoader';

/**
 * router management component to manage the application level routes
 *
 */
const Router = (): JSX.Element => {

  const [pageRoutes, setPageRoutes] = useState([] as routeInfo[]);  
   // initialize the route dependencies
   useEffect(() => {
    if (!pageRoutes || pageRoutes?.length < 1) {
      const list = expandPagePaths(routes);
      setPageRoutes(list);      
    }    
  },[pageRoutes]);
  
  if (!pageRoutes || pageRoutes.length < 1) {
    return (<></>);
  }
  
  return (
    <Routes>
      {pageRoutes.map((routeItem) => {
        return (
          <Route
            key={routeItem.key}
            path={routeItem.path}
            element={
                <routeItem.elm />
            }
          />
        );}
      )}
    </Routes>
  );
};

/**
 * Get the routes for the PPM edition
 * @param routes the route configuration
 * @returns the route information for this editions
 */
const getPpmRoutes = () : routeInfo[] => {
  return expandPagePaths(routes);
};

export default memo(Router);
export {
  getPpmRoutes
}
